import { useMemo } from 'react';
import { CampaignType_Enum as CampaignType } from '@weave/schema-gen-ts/dist/schemas/messaging/bulk/v2';
import { useTranslation } from '@frontend/i18n';
import { Button } from '@frontend/design-system';
import { useBulkNavigator } from '../../hooks/use-bulk-navigator';

type Props = {
  /** An undefined campaign type means both email and text campaigns should be handled, ie: the drafts page */
  campaignType?: CampaignType;
  disabled?: boolean;
  trackingIdPrefix: string;
};

export const SingleCampaignButton = ({ campaignType, disabled = false, trackingIdPrefix }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const navigateTo = useBulkNavigator(campaignType);

  const label = useMemo(() => {
    if (campaignType === undefined) {
      return t('New Campaign');
    }
    if (campaignType === CampaignType.EMAIL) {
      return t('New Email Campaign');
    }
    return t('New Text Campaign');
  }, [campaignType, t]);

  return (
    <Button
      disabled={disabled}
      onClick={() => navigateTo.editor()}
      size='large'
      trackingId={`${trackingIdPrefix}-new-campaign-btn`}
    >
      {label}
    </Button>
  );
};
